export const anim = {
  v: '5.5.7',
  meta: { g: 'LottieFiles AE 0.1.20', a: '', k: '', d: '', tc: '' },
  fr: 60,
  ip: 0,
  op: 226,
  w: 474,
  h: 420,
  nm: 'Mark - Black on transparent background',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'bottom mask',
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [136.556, 277.543, 0], ix: 2 },
        a: { a: 0, k: [907.135, 575.549, 0], ix: 1 },
        s: { a: 0, k: [190, 190, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [13.563, -23.377],
                        [0.669, -3.915],
                        [12.275, 5.787],
                        [28.885, 17.493],
                        [-11.416, 9.002],
                        [-7.574, 3.451],
                        [-2.049, 0.393],
                        [-3.219, -1.001],
                        [0.21, -10.663],
                        [-0.162, -1.74],
                      ],
                      o: [
                        [-2.745, 4.731],
                        [-2.286, 13.376],
                        [-10.934, -5.155],
                        [-12.436, -7.531],
                        [19.64, -15.488],
                        [1.898, -0.865],
                        [3.445, -0.661],
                        [6.515, 2.026],
                        [-0.029, 1.481],
                        [0, 0],
                      ],
                      v: [
                        [56.051, 23.246],
                        [52.287, 42.322],
                        [23.186, 57.062],
                        [-46.347, 18.026],
                        [-47.836, -16.044],
                        [19.781, -55.498],
                        [25.709, -57.395],
                        [37.697, -58.781],
                        [51.429, -40.443],
                        [51.624, -34.549],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'st',
                  c: { a: 0, k: [0.815686285496, 0, 0.109803922474, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 33, ix: 5 },
                  lc: 2,
                  lj: 2,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [907.135, 575.549], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'bottom mask',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'tm',
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              { i: { x: [0.924], y: [1] }, o: { x: [0.823], y: [0] }, t: 1, s: [0] },
              { i: { x: [0.924], y: [1] }, o: { x: [0.167], y: [0] }, t: 60, s: [100] },
              { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0] }, t: 120, s: [100] },
              { t: 180, s: [0] },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 0,
      op: 39600,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: '.logo-mark-bottom',
      cl: 'logo-mark-bottom',
      tt: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [237, 210, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [190, 190, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [23.342, 13.393],
                    [0, 0],
                    [0, 0],
                    [0, -26.786],
                    [0, 0],
                    [-2.142, -1.229],
                    [0, 0],
                    [0, 5.202],
                    [0, 0],
                    [-4.592, -2.634],
                    [0, 0],
                    [0, 0],
                    [4.613, -2.647],
                    [0, 0],
                    [0, 0],
                    [0, 5.294],
                    [0, 0],
                    [23.233, -13.33],
                    [0, 0],
                    [0, 0],
                    [-23.342, -13.393],
                    [0, 0],
                    [0, 0],
                    [0, 26.786],
                    [0, 0],
                    [2.142, 1.229],
                    [0, 0],
                    [0, -5.202],
                    [0, 0],
                    [4.592, 2.634],
                    [0, 0],
                    [0, 0],
                    [-4.613, 2.647],
                    [0, 0],
                    [0, 0],
                    [0, -5.294],
                    [0, 0],
                    [-23.233, 13.33],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [-23.233, -13.33],
                    [0, 0],
                    [0, 2.47],
                    [0, 0],
                    [4.512, 2.589],
                    [0, 0],
                    [0, -5.294],
                    [0, 0],
                    [0, 0],
                    [4.613, 2.647],
                    [0, 0],
                    [0, 0],
                    [-4.592, 2.634],
                    [0, 0],
                    [0.001, -26.786],
                    [0, 0],
                    [0, 0],
                    [-23.342, 13.393],
                    [0, 0],
                    [0, 0],
                    [23.233, 13.33],
                    [0, 0],
                    [0, -2.47],
                    [0, 0],
                    [-4.512, -2.589],
                    [0, 0],
                    [0, 5.294],
                    [0, 0],
                    [0, 0],
                    [-4.613, -2.647],
                    [0, 0],
                    [0, 0],
                    [4.592, -2.634],
                    [0, 0],
                    [0, 26.786],
                    [0, 0],
                    [0, 0],
                    [23.342, -13.393],
                  ],
                  v: [
                    [106.878, -65.911],
                    [72.316, -85.741],
                    [37.263, -105.853],
                    [-14.93, -75.625],
                    [-14.93, -71.111],
                    [-11.467, -65.131],
                    [4.795, -55.8],
                    [14.93, -61.67],
                    [14.93, -72.361],
                    [25.245, -78.335],
                    [57.282, -59.954],
                    [89.221, -41.628],
                    [89.221, -29.68],
                    [57.282, -11.355],
                    [25.245, 7.026],
                    [14.93, 1.052],
                    [14.931, -4.259],
                    [-37.262, -34.487],
                    [-72.316, -14.375],
                    [-106.878, 5.455],
                    [-106.878, 65.911],
                    [-72.316, 85.741],
                    [-37.263, 105.853],
                    [14.931, 75.625],
                    [14.931, 71.1],
                    [11.467, 65.12],
                    [-4.795, 55.789],
                    [-14.93, 61.659],
                    [-14.93, 72.361],
                    [-25.245, 78.335],
                    [-57.282, 59.953],
                    [-89.221, 41.628],
                    [-89.221, 29.68],
                    [-57.282, 11.355],
                    [-25.245, -7.027],
                    [-14.93, -1.053],
                    [-14.93, 4.259],
                    [37.263, 34.486],
                    [72.316, 14.375],
                    [106.878, -5.455],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0, 0.007843137719, 1],
                ix: 4,
                x: "var $bm_rt;\nvar rayColorPalette, rayColorSwatch;\nrayColorPalette = comp('Ray - LogoMotion ');\nrayColorSwatch = Math.floor($bm_mul(value[2], 255));\ntry {\n    $bm_rt = rayColorPalette.layer(1)(4)(rayColorSwatch)(1);\n} catch (e) {\n    $bm_rt = value;\n}",
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 5,
      op: 246,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'top mask',
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [337.51, 141.632, 0], ix: 2 },
        a: { a: 0, k: [1013.426, 504.017, 0], ix: 1 },
        s: { a: 0, k: [190, 190, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-6.554, 11.526],
                        [0, 0],
                        [-7.276, -3.55],
                        [-15.349, -11.436],
                        [8.827, -7.093],
                        [15.167, -7.437],
                        [7.815, 9.511],
                        [0.48, 5.149],
                      ],
                      o: [
                        [3.524, -6.197],
                        [4.621, -6.648],
                        [20.861, 10.179],
                        [9.08, 6.766],
                        [-17.375, 13.962],
                        [-11.053, 5.419],
                        [-2.436, -2.965],
                        [0, 0],
                      ],
                      v: [
                        [-55.49, -23.269],
                        [-51.271, -51.602],
                        [-25.602, -56.988],
                        [48.524, -15.189],
                        [49.021, 14.186],
                        [-21.062, 55.588],
                        [-50.397, 49.816],
                        [-54.667, 34.983],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'st',
                  c: { a: 0, k: [0.815686285496, 0, 0.109803922474, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 33, ix: 5 },
                  lc: 2,
                  lj: 2,
                  bm: 0,
                  nm: 'Stroke 1',
                  mn: 'ADBE Vector Graphic - Stroke',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [1013.426, 504.017], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'top mask',
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'tm',
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              { i: { x: [0.924], y: [1] }, o: { x: [0.823], y: [0] }, t: 1, s: [0] },
              { i: { x: [0.924], y: [1] }, o: { x: [0.167], y: [0] }, t: 60, s: [100] },
              { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0] }, t: 120, s: [100] },
              { t: 180, s: [0] },
            ],
            ix: 2,
          },
          o: { a: 0, k: 0, ix: 3 },
          m: 1,
          ix: 2,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 0,
      op: 39600,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: '.logo-mark-top',
      cl: 'logo-mark-top',
      tt: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [237, 210, 0], ix: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1 },
        s: { a: 0, k: [190, 190, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [23.342, 13.393],
                    [0, 0],
                    [0, 0],
                    [0, -26.786],
                    [0, 0],
                    [-2.142, -1.229],
                    [0, 0],
                    [0, 5.202],
                    [0, 0],
                    [-4.592, -2.634],
                    [0, 0],
                    [0, 0],
                    [4.613, -2.647],
                    [0, 0],
                    [0, 0],
                    [0, 5.294],
                    [0, 0],
                    [23.233, -13.33],
                    [0, 0],
                    [0, 0],
                    [-23.342, -13.393],
                    [0, 0],
                    [0, 0],
                    [0, 26.786],
                    [0, 0],
                    [2.142, 1.229],
                    [0, 0],
                    [0, -5.202],
                    [0, 0],
                    [4.592, 2.634],
                    [0, 0],
                    [0, 0],
                    [-4.613, 2.647],
                    [0, 0],
                    [0, 0],
                    [0, -5.294],
                    [0, 0],
                    [-23.233, 13.33],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [-23.233, -13.33],
                    [0, 0],
                    [0, 2.47],
                    [0, 0],
                    [4.512, 2.589],
                    [0, 0],
                    [0, -5.294],
                    [0, 0],
                    [0, 0],
                    [4.613, 2.647],
                    [0, 0],
                    [0, 0],
                    [-4.592, 2.634],
                    [0, 0],
                    [0.001, -26.786],
                    [0, 0],
                    [0, 0],
                    [-23.342, 13.393],
                    [0, 0],
                    [0, 0],
                    [23.233, 13.33],
                    [0, 0],
                    [0, -2.47],
                    [0, 0],
                    [-4.512, -2.589],
                    [0, 0],
                    [0, 5.294],
                    [0, 0],
                    [0, 0],
                    [-4.613, -2.647],
                    [0, 0],
                    [0, 0],
                    [4.592, -2.634],
                    [0, 0],
                    [0, 26.786],
                    [0, 0],
                    [0, 0],
                    [23.342, -13.393],
                  ],
                  v: [
                    [106.878, -65.911],
                    [72.316, -85.741],
                    [37.263, -105.853],
                    [-14.93, -75.625],
                    [-14.93, -71.111],
                    [-11.467, -65.131],
                    [4.795, -55.8],
                    [14.93, -61.67],
                    [14.93, -72.361],
                    [25.245, -78.335],
                    [57.282, -59.954],
                    [89.221, -41.628],
                    [89.221, -29.68],
                    [57.282, -11.355],
                    [25.245, 7.026],
                    [14.93, 1.052],
                    [14.931, -4.259],
                    [-37.262, -34.487],
                    [-72.316, -14.375],
                    [-106.878, 5.455],
                    [-106.878, 65.911],
                    [-72.316, 85.741],
                    [-37.263, 105.853],
                    [14.931, 75.625],
                    [14.931, 71.1],
                    [11.467, 65.12],
                    [-4.795, 55.789],
                    [-14.93, 61.659],
                    [-14.93, 72.361],
                    [-25.245, 78.335],
                    [-57.282, 59.953],
                    [-89.221, 41.628],
                    [-89.221, 29.68],
                    [-57.282, 11.355],
                    [-25.245, -7.027],
                    [-14.93, -1.053],
                    [-14.93, 4.259],
                    [37.263, 34.486],
                    [72.316, 14.375],
                    [106.878, -5.455],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0, 0.007843137719, 1],
                ix: 4,
                x: "var $bm_rt;\nvar rayColorPalette, rayColorSwatch;\nrayColorPalette = comp('Ray - LogoMotion ');\nrayColorSwatch = Math.floor($bm_mul(value[2], 255));\ntry {\n    $bm_rt = rayColorPalette.layer(1)(4)(rayColorSwatch)(1);\n} catch (e) {\n    $bm_rt = value;\n}",
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 5,
      op: 230,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}
